import PrimaryMedium from "./PrimaryMedium";

export default PrimaryMedium;
export { PrimaryMedium as H2 };
